import { Switch, Route } from "wouter";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/api";
import { useAdminAuth } from "./hooks/use-admin-auth";
import { AdminLayout } from "./components/admin-layout";
import { LoginForm } from "./components/login-form";

import Dashboard from "./pages/dashboard";
import UsersPage from "./pages/users";
import UserProfilePage from "./pages/user-profile";
import PaymentsPage from "./pages/payments";
import RecurringPaymentsPage from "./pages/recurring-payments";
import TicketsPage from "./pages/tickets";
import TicketDetailPage from "./pages/ticket-detail";
import ChatsPage from "./pages/chats";
import ChatDetailPage from "./pages/chat-detail";
import ForecastPage from "./pages/forecast";
import BlogPostsPage from "./pages/blog-posts";
import BlogEditorPage from "./pages/blog-editor";
import HhScannerPage from "./pages/hh-scanner";
import AvitoPlatformListingsPage from "./pages/avito-platform-listings";
import ClientTranscriptsPage from "./pages/client-transcripts";
import BotTestPage from "./pages/bot-test";
import DailyReportsPage from "./pages/daily-reports";
import DelegationPage from "./pages/delegation";
import PartnerApplicationsPage from "./pages/partner-applications";

function AuthenticatedRoutes() {
  return (
    <AdminLayout>
      <Switch>
        <Route path="/" component={Dashboard} />
        <Route path="/users" component={UsersPage} />
        <Route path="/users/:id" component={UserProfilePage} />
        <Route path="/payments" component={PaymentsPage} />
        <Route path="/recurring" component={RecurringPaymentsPage} />
        <Route path="/tickets" component={TicketsPage} />
        <Route path="/tickets/:id" component={TicketDetailPage} />
        <Route path="/chats" component={ChatsPage} />
        <Route path="/chats/:id" component={ChatDetailPage} />
        <Route path="/forecast" component={ForecastPage} />
        <Route path="/blog" component={BlogPostsPage} />
        <Route path="/blog/new" component={BlogEditorPage} />
        <Route path="/blog/:id" component={BlogEditorPage} />
        <Route path="/hh-scanner" component={HhScannerPage} />
        <Route path="/avito-platform-listings" component={AvitoPlatformListingsPage} />
        <Route path="/client-transcripts" component={ClientTranscriptsPage} />
        <Route path="/bot-test" component={BotTestPage} />
        <Route path="/daily-reports" component={DailyReportsPage} />
        <Route path="/delegation" component={DelegationPage} />
        <Route path="/partner-applications" component={PartnerApplicationsPage} />
        <Route>
          <div className="text-center py-20 text-muted-foreground">
            Страница не найдена
          </div>
        </Route>
      </Switch>
    </AdminLayout>
  );
}

function Router() {
  const { isAuthenticated, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-pulse">
          <div className="w-8 h-8 rounded-lg bg-primary/20" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginForm />;
  }

  return <AuthenticatedRoutes />;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router />
    </QueryClientProvider>
  );
}

export default App;
